import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Sidebar   from './components/Sidebar';
import Login     from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users     from './pages/Users';
import Content   from './pages/Content';
import Announcements from './pages/Announcements';
import Roles     from './pages/Roles';
import Feedback  from './pages/Feedback';
import Analytics from './pages/Analytics';
import Posts         from './pages/Posts';
import Books         from './pages/Books';
import HomeTabs      from './pages/HomeTabs';
import Quotes        from './pages/Quotes';
import Audio         from './pages/Audio';
import Video         from './pages/Video';
import ResetPassword from './pages/ResetPassword';
import { Spinner } from './components/UI';
import './index.css';

function ProtectedLayout() {
  const { user, loading } = useAuth();

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <Spinner size={36}/>
    </div>
  );

  if (!user || !user.roles?.includes('Admin')) return <Navigate to="/login" replace/>;

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar/>
      <main style={{ flex: 1, overflowY: 'auto', background: 'var(--bg)' }}>
        <Outlet/>
      </main>
    </div>
  );
}

function PublicRoute() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user?.roles?.includes('Admin')) return <Navigate to="/" replace/>;
  return <Outlet/>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/reset-password" element={<ResetPassword/>}/>
          <Route element={<PublicRoute/>}>
            <Route path="/login" element={<Login/>}/>
          </Route>
          <Route element={<ProtectedLayout/>}>
            <Route path="/"              element={<Dashboard/>}/>
            <Route path="/users"         element={<Users/>}/>
            <Route path="/roles"         element={<Roles/>}/>
            <Route path="/content"       element={<Content/>}/>
            <Route path="/posts"         element={<Posts/>}/>
            <Route path="/books"         element={<Books/>}/>
            <Route path="/home-tabs"     element={<HomeTabs/>}/>
            <Route path="/quotes"        element={<Quotes/>}/>
            <Route path="/audio"         element={<Audio/>}/>
            <Route path="/video"         element={<Video/>}/>
            <Route path="/announcements" element={<Announcements/>}/>
            <Route path="/feedback"      element={<Feedback/>}/>
            <Route path="/analytics"     element={<Analytics/>}/>
          </Route>
          <Route path="*" element={<Navigate to="/" replace/>}/>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
